// Import your icons
import HomeIcon from "@mui/icons-material/Home";
import SubAdminIcon from "@mui/icons-material/AdminPanelSettingsOutlined";
import UsersIcon from "@mui/icons-material/SupervisorAccount";
import OrdersIcon from "@mui/icons-material/PendingActionsOutlined";
import EditPaperIcon from "@mui/icons-material/NoteAltOutlined";
import AddPaperIcon from "@mui/icons-material/AddHomeWorkOutlined";
import StoreIcon from "@mui/icons-material/StorefrontOutlined";
import FactoryIcon from "@mui/icons-material/FactoryOutlined";
import DepartmentsIcon from "@mui/icons-material/Category";
import DiscountIcon from "@mui/icons-material/DiscountOutlined";
import ProductsIcon from "@mui/icons-material/ShoppingBagOutlined";
import ProductsOrdersIcon from "@mui/icons-material/TakeoutDiningOutlined";
import SupportIcon from "@mui/icons-material/SupportAgentOutlined";
import MediaIcon from "@mui/icons-material/AddPhotoAlternateOutlined";
import SettingsIcon from "@mui/icons-material/SettingsOutlined";
import NotificationsIcon from "@mui/icons-material/NotificationsActiveOutlined";
import ContactIcon from "@mui/icons-material/RecentActorsOutlined";
import usePermissions from "../../hooks/usePermissions";

export const SidebarList = (userPermissions = [], userRole = "") => {
  // Define all sidebar items with permissions
  const allItems = [
    {
      label: "لوحة التحكم",
      path: "/",
      icon: <HomeIcon className="icon" />,
      permissionId: 1, // "رؤية لوحة التحكم"
    },
    {
      label: "المسؤلين الفرعين",
      path: "/admins",
      icon: <SubAdminIcon className="icon" />,
      permissionId: 14, // "رؤية المسؤلين الفرعين"
    },

    {
      label: "المستخدمين",
      path: "/users",
      icon: <UsersIcon className="icon" />,
      permissionId: 22, // "رؤية المستخدمين"
    },
    {
      label: "طلبات اضافة و تعديل المنتجات",
      path: "/add-products",
      icon: <OrdersIcon className="icon" />,
      permissionId: 68, // "رؤية الطلبات علي المنتجات"
    },
    {
      label: "طلبات تعديل اوراق المتاجر/المصانع",
      path: "/edit-partners",
      icon: <EditPaperIcon className="icon" />,
      permissionId: 39, // "رؤية طلبات التعديل علي الاوراق"
    },
    {
      label: "طلبات تسجيل المتاجر/المصانع",
      path: "/add-partners",
      icon: <AddPaperIcon className="icon" />,
      permissionId: 42, // "رؤية طلبات تسجيل المتاجر / المصانع"
    },
    {
      label: "المتاجر",
      path: "/shops",
      icon: <StoreIcon className="icon" />,
      permissionId: 29, // "رؤية المتاجر"
    },
    {
      label: "المصانع",
      path: "/factories",
      icon: <FactoryIcon className="icon" />,
      permissionId: 129, // "رؤية المصانع"
    },
    {
      label: "الاقسام",
      path: "/departments",
      icon: <DepartmentsIcon className="icon" />,
      permissionId: 92, // "رؤية الاقسام"
    },
    {
      label: "اكواد الخصم",
      path: "/discount-codes",
      icon: <DiscountIcon className="icon" />,
      permissionId: 49, // "رؤية اكواد الخصم"
    },
    {
      label: "المنتجات",
      path: "/products",
      icon: <ProductsIcon className="icon" />,
      permissionId: 78, // "رؤية المنتجات"
    },
    {
      label: "الطلبات على المنتجات",
      path: "/product-orders",
      icon: <ProductsOrdersIcon className="icon" />,
      permissionId: 68, // "رؤية الطلبات علي المنتجات" (duplicated, but kept as in original)
    },
    {
      label: "الاشعارات",
      path: "/notifications",
      icon: <NotificationsIcon className="icon" />,
      permissionId: 114, // "رؤية الاشعارات"
    },
    {
      label: "الدعم الفني",
      path: "/support",
      icon: <SupportIcon className="icon" />,
      permissionId: 123, // "رؤية رسائل الدعم الفني"
    },
    {
      label: "تواصل معنا",
      path: "/contact-us",
      icon: <ContactIcon className="icon" />,
      permissionId: 123, // "رؤية رسائل الدعم الفني"
    },

    {
      label: "الصور الاعلانية للموقع",
      path: "/banners",
      icon: <MediaIcon className="icon" />,
      permissionId: 110, // "رؤية الصور الاعلانية للموقع"
    },
    {
      label: "اعدادات عامة",
      path: "/settings",
      icon: <SettingsIcon className="icon" />,
      permissionId: 142, // "رؤية الاعدادات العامة"
    },
  ];

  // For admin users, show all menu items
  if (userRole === "admin") {
    return allItems;
  }

  // For other users, filter items based on permissions
  return allItems.filter((item) => userPermissions.includes(item.permissionId));
};

// Enhanced SidebarWithPermissions component that uses the usePermissions hook
export const SidebarWithPermissions = () => {
  const { userPermissions, isAdmin } = usePermissions();

  // Get the sidebar items based on permissions
  const sidebarItems = SidebarList(userPermissions, isAdmin ? "admin" : "user");

  return sidebarItems;
};

export default SidebarList;
